import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { RequestDto } from 'src/portal/ai-proxy-api/models/request-dto';
import { ProxyService } from 'src/portal/ai-proxy-api/services/proxy.service';

export interface ChatMessage {
  text: string;
  sender: 'user' | 'bot';
  timestamp: Date;
  isTyping?: boolean;
  companies?: CompanyDomain[];
}

export interface CompanyDomain {
  company_name: string;
  domain: string;
}

export enum ChatCommand {
  FindEmployees = 'Find profiles of employees',
  FindCustomers = 'Find customers of products',
  AnalyzeTechStacks = 'Analyze tech stacks for company',
  RecommendSoftware = 'Recommend software',
  BenchmarkCompanies = 'Benchmark companies',
  GeneralMode = 'General Mode',
  ProductAnalysis = 'Product Analysis',
  TrendAnalysis = 'Trend Analysis',
}

interface CompanyDomainsData {
  company_domains?: unknown;
  [key: string]: unknown;
}

interface ModelConfig {
  systemInstruction: string;
  temperature?: number;
  tools?: object[];
  thinkingConfig?: object;
}

@Injectable({
  providedIn: 'root',
})
export class AiChatProxyService {
  constructor(
    public proxyService: ProxyService,
    private authService: AuthService
  ) {
  }

  public async *sendMessage(
    requestDto: RequestDto,
    sessionId: string
  ): AsyncGenerator<string, void, unknown> {
    const token = this.authService.getAccessToken();
    const body = JSON.stringify({ ...requestDto, sessionId });

    const response = await fetch('https://api.salescaddy.ai/ai-proxy-api/user/proxy', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
        Authorization: `Bearer ${token}`,
      },
      body,
    });

    if (!response.ok || !response.body) {
      throw new Error(`Stream error: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder(); // безопасный по умолчанию
    let buffer = '';
    let partialDataBlock: string[] = [];

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value);

      let lines = buffer.split('\n');
      buffer = lines.pop() || ''; // оставим незавершённую строку в буфере

      for (const line of lines) {
        if (line.startsWith('data:')) {
          partialDataBlock.push(line.slice(5)); // не .trim() — чтобы не ломать формат
        } else if (line.trim() === '') {
          // завершение блока
          if (partialDataBlock.length > 0) {
            yield partialDataBlock.join('\n');
            partialDataBlock = [];
          }
        }
      }
    }

    // последний фрагмент, если остался
    if (partialDataBlock.length > 0) {
      yield partialDataBlock.join('\n');
    }
  }




}
